import React, { FC, useEffect } from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";
import { useFeatureFlags } from "../components/feature-flag/use-feature-flags";
import { useNavigation, useUser } from "../hooks";
import { User } from "../models/user";
import { useAppDispatch } from "../store";
import { NavigationThunk } from "../store/navigation/thunks";
import { UserThunk } from "../store/user/thunks";
import { FFRoute } from "./feature-flag-route";
import { availableRoutes } from "./routes";

type Props = {
  component: any;
} & RouteProps;

export const PrivateRoute: FC<Props> = ({ component: Component, ...rest }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { user } = useUser();
  const { navigation } = useNavigation();
  const { isLoading } = useFeatureFlags();

  const getUserInfo = async () => {
    const user = (await (await dispatch(UserThunk())).payload) as User;
    if (navigation.length === 0) {
      await dispatch(NavigationThunk());
    }

    if (user?.email) {
      history.push({ pathname: history.location.pathname || availableRoutes.default, search: history.location.search });
    } else {
      history.push(availableRoutes.generalSignIn);
    }
  };
  useEffect(() => {
    if (!user.email) {
      getUserInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.email]);

  if (rest.location?.search?.includes("tid=")) {
    return (
      <Route
        {...rest}
        render={props => {
          return user.isAuthenticated ? (
            <FFRoute
              {...props}
              redirectUrl={`/courses/provider?provider=${props.location.search.split("tid=")[1]}`}
              allowedFlags={["COURSE_LIST_PAGE_REACT_MIGRATION"]}
            />
          ) : null;
        }}
      />
    );
  }

  return (
    <Route
      {...rest}
      render={props => {
        return user.isAuthenticated && isLoading === false ? <Component {...props} /> : null;
      }}
    />
  );
};
